<template>
	<div class="relative grow flex items-center gap-3">
		<i class="fa-solid fa-spinner animate-spin"/>
		{{ $t('general.searching') }}
	</div>
</template>
<script setup lang="ts"></script>